const { VUE_APP_API_URL: RUTA_GLOBAL } = process.env

// ── Helper interno ─────────────────────────────────────────────────────────
// Parsea la respuesta JSON y lanza un Error con el mensaje legible si el
// servidor indicó error: true (manejado en encabezado.php) o si el status
// HTTP no es 2xx.
async function procesarRespuesta(respuesta) {
  let resultado

  try {
    resultado = await respuesta.json()
  } catch {
    // La respuesta no es JSON válido (ej. PHP produjo HTML de error)
    throw new Error('El servidor devolvió una respuesta inválida. Por favor intenta de nuevo.')
  }

  // El servidor devolvió { error: true, mensaje: '...' }
  if (resultado && resultado.error === true) {
    throw new Error(resultado.mensaje || 'Ocurrió un error. Por favor intenta de nuevo.')
  }

  // HTTP 4xx / 5xx sin el campo error (compatibilidad con respuestas antiguas)
  if (!respuesta.ok) {
    throw new Error('Error en el servidor (HTTP ' + respuesta.status + '). Por favor intenta de nuevo.')
  }

  return resultado
}

const HttpService = {
  async registrar(ruta, datos) {
    const respuesta = await fetch(`${RUTA_GLOBAL}/${ruta}`, {
      method: 'post',
      body: JSON.stringify(datos),
      credentials: 'include',
    })
    return procesarRespuesta(respuesta)
  },

  async obtener(ruta) {
    const respuesta = await fetch(`${RUTA_GLOBAL}/${ruta}`, { credentials: 'include' })
    return procesarRespuesta(respuesta)
  },

  async editar(ruta, datos) {
    const respuesta = await fetch(`${RUTA_GLOBAL}/${ruta}`, {
      method: 'post',
      body: JSON.stringify(datos),
      credentials: 'include',
    })
    return procesarRespuesta(respuesta)
  },

  async eliminar(ruta, datos) {
    const respuesta = await fetch(`${RUTA_GLOBAL}/${ruta}`, {
      method: 'post',
      body: JSON.stringify(datos),
      credentials: 'include',
    })
    return procesarRespuesta(respuesta)
  },

  async obtenerConConsultas(ruta, payload) {
    const respuesta = await fetch(`${RUTA_GLOBAL}/${ruta}`, {
      method: 'post',
      body: JSON.stringify(payload),
      credentials: 'include',
    })
    return procesarRespuesta(respuesta)
  },
}

export default HttpService
